const TipoAtendimento = {
  WhatsApp: 1,
  Facebook: 2,
  Email: 3,
  Instagram: 4
};

export default TipoAtendimento;
